import { render, staticRenderFns } from "./RatingDisplay.vue?vue&type=template&id=a8dc1420&"
import script from "./RatingDisplay.vue?vue&type=script&lang=js&"
export * from "./RatingDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8dc1420')) {
      api.createRecord('a8dc1420', component.options)
    } else {
      api.reload('a8dc1420', component.options)
    }
    module.hot.accept("./RatingDisplay.vue?vue&type=template&id=a8dc1420&", function () {
      api.rerender('a8dc1420', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bQye5LDXI9qI/JS/comp/RatingDisplay.vue"
export default component.exports